import Modal from './modal';

class PhotoGalleryLauncher {
    /**
     * This class initializes a new Modals by finding instances of
     * the `js-photo-gallery-launch-button` class scoped to the url
     * of the story via data attribute
     * @param  {object} config contains the jquery object for item,
     *                         slideIndex, and isMobile
     * @return {obj} instance of PhotoGalleryLauncher
     */
    constructor(config) {
        this.$slideshow = config.$item;
        this.slideNumberParam = config.slideNumberParam;
        this.isMobile = config.isMobile;
    }
    /**
     * Attaches click listeners to the photoLauncher button for each individual instance
     * of a photogallery. Clicking creates a new instance of the Modal class,
     * and calls that instance of Modal's open.
     * If there is a slide param provided in th URL, init also launches the modal
     * right way.
     * @return {undefined}
     */
    init() {
        const modalConfig = {
            $slideshow: this.$slideshow,
            slideNumberParam: this.slideNumberParam,
            isMobile: this.isMobile
        };


        if (this.slideNumberParam !== 1 && this.slideNumberParam) {
            let myModal = new Modal(modalConfig);
            myModal.open();
        }

        $(`.js-photo-gallery-launch-button[data-url="${this.$slideshow.data('url')}"]`).click(() => {
            modalConfig.slideNumberParam = 0;
            let myModal = new Modal(modalConfig);
            myModal.open();
        });
    }
}

export default PhotoGalleryLauncher;
